import { createReducer, INITIAL_STATE } from '@shared/redux';
import { LOAD_STATE } from '@shared/axios/axios.constants';
import { convertCampaignsToHash } from '@domain/campaigns';
import { getCampaignsInfoConfig } from './campaigns-info.api';
import { getExtraFieldsForCampaignsInfo } from './campaigns-info.utils';
import { HashedCampaignsInfo } from './campaigns-info.types';

export const GET_CAMPAIGNS_INFO_REQUEST_CALLED = '@campaigns-info/GET_CAMPAIGNS_INFO_REQUEST_CALLED';
export const GET_CAMPAIGNS_INFO_REQUEST_SUCCEEDED = '@campaigns-info/GET_CAMPAIGNS_INFO_REQUEST_SUCCEEDED';
export const GET_CAMPAIGNS_INFO_REQUEST_FAILED = '@campaigns-info/GET_CAMPAIGNS_INFO_REQUEST_FAILED';
export const GET_CAMPAIGNS_INFO_REQUEST_CANCELED = '@campaigns-info/GET_CAMPAIGNS_INFO_REQUEST_CANCELED';
export const HANDLE_GET_CAMPAIGNS_INFO_REPORT = '@campaigns-info/HANDLE_GET_CAMPAIGNS_INFO_REPORT';

export const getCampaignsInfo = state => state.campaignsInfo;
export const getCampaignsInfoWarning = state => state.campaignsInfo?.warning;


export const handleGetCampaignsInfoReport = () => ({
    type: HANDLE_GET_CAMPAIGNS_INFO_REPORT,
    payload: {},
});

export const getCampaignsInfoRequest = ({
    clientId,
    startDate,
    endDate,
}) => ({
    type: GET_CAMPAIGNS_INFO_REQUEST_CALLED,
    actionTypes: {
        success: GET_CAMPAIGNS_INFO_REQUEST_SUCCEEDED,
        fail: GET_CAMPAIGNS_INFO_REQUEST_FAILED,
        canceled: GET_CAMPAIGNS_INFO_REQUEST_CANCELED,
    },
    config: getCampaignsInfoConfig({
        clientId,
        startDate,
        endDate,
    }),
});


interface CampaignsInfoState {
    loadState: string,
    data: HashedCampaignsInfo,
    error: string
    warning: {
        message: string,
        account: string,
        platform: string
    } | null
}

const initialState: CampaignsInfoState = {
    loadState: LOAD_STATE.LOADING,
    data: {},
    error: null,
    warning: null,
};

export const CampaignsInfoReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_CAMPAIGNS_INFO_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        data: {},
        error: null,
    }),
    [GET_CAMPAIGNS_INFO_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: convertCampaignsToHash({
            report: action.payload.data,
            extraFieldsGetter: getExtraFieldsForCampaignsInfo,
        }),
        error: null,
        warning: action.payload.data?.warning,
    }),
    [GET_CAMPAIGNS_INFO_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        data: {},
        error: action.payload,
    }),
    [GET_CAMPAIGNS_INFO_REQUEST_CANCELED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        data: {},
        error: action.payload,
    }),
});
